import { httpClient } from "./client";
import type { VodaActualizacionDatosPayload } from "../custom/actualizacion-datos/ActualizacionDatosTypes";

/**
 * Endpoint custom exclusivo de Voda Argentina: envia por mail una actualizacion de
 * datos personales del cliente (sin carrito ni orden). Ver backend
 * Controller/CustomController/Voda/VodaActualizacionDatosController.cs.
 */
export const HttpVodaActualizacionDatos = {
    enviar: (payload: VodaActualizacionDatosPayload): Promise<void> =>
        httpClient.post<void>("custom/voda/actualizacion-datos", payload),
};
